<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">語言服務、出版與媒體</h1>
                        <h2>提升寫作品質與編輯流程效率</h2>
                        <p>幫助您的團隊維持一致的寫作風格，加快出版速度，並提升客戶體驗。減少編輯時間與成本，同時不犧牲內容的清晰度、一致性、品牌形象與風格。</p>
                        <div class="btn-group">
                            <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">聯繫我們</button>
                            <a href="https://calendly.com/trinkaai/meet" target="_blank" id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/enterprise/language-services-publishing-and-media.webp" width="500" height="476" alt="Trinka enterprise" class="img-fluid md50" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd trinka-key-features">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>專為以下產業量身打造的解決方案</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="gt-features three-coloum">
                    <span class="hr-line d-sm-block d-none"></span>
                    <span class="vr-line l25"></span>
                    <span class="vr-line l50 d-sm-none"></span>
                    <span class="vr-line l75"></span>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>編輯與校對公司</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>媒體與出版社</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>部落客與部落格網站</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>翻譯服務公司</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>印前製作公司</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>行銷代理商</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd-sm bg-light">
    <app-trusted-global-leaders [sliderData]="globalSliderData"></app-trusted-global-leaders>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>助企業團隊提升寫作品質的功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 協助您的團隊高效完成重要文件，同時確保品質與符合科學寫作規範。</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                    <div class="features_cards_icon">
                        <img src="/assets/images/BulkEditingOperations.svg" width="40" height="40" alt="bulk editing" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>
                            批次編輯作業
                        </h3>
                        <p>只要上傳 MS Word 文件，Trinka 就能在幾分鐘內自動編輯完成。您只需下載帶有修改標註的檔案，並檢視確認內容即可。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title">
                    <div class="features_cards_icon">
                        <img src="/assets/images/AddtoDictionary.svg" width="40" height="40" alt="medical" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>語境拼字檢查與字典</h3>
                        <p>
                            Trinka 內建拼字檢查功能，能分辨「from」與「form」等易混淆字詞，並收錄數百萬專業術語。每位成員可建立個人詞典，或共享團隊字典，輕鬆維持品牌用語一致性。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/WordCountreductions.png" width="40" height="40" alt="word count" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>字數刪減</h3>
                        <p>Trinka 幫助您簡潔有力地表達重點，讓訊息更具影響力。您的團隊還能在寫作中持續學習！</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/Suggestionsthatmatchyourtone.png" width="40" height="40" alt="suggestion" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>符合語氣的建議</h3>
                        <p>
                            無論是撰寫輕鬆的文章或正式文件，Trinka 都能提供合適的建議。針對研究文件，還能設定不同研究類型，例如原創研究、文獻回顧或個案報告。
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/EasyUserManagement.svg" width="40" height="40" alt="easy management" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>簡易用戶管理</h3>
                        <p>
                            團隊帳號讓您輕鬆新增或移除成員，並即時管理使用額度與權限。無論是內部團隊或外包人才，都能透過 Trinka 細緻的權限控管，安全管理存取。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/ppc_icon.png" width="40" height="40" alt="ppc" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>
                            抄襲檢查
                        </h3>
                        <p>整合全球最大學術資料庫，提供高準確度的原創性檢測。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/ComprehensiveAnalytics.svg" width="40" height="40" alt="comprehensive" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>完整數據分析</h3>
                        <p>可檢視整體學習成效，或針對個別學生進行深入追蹤與診斷，提升教學成效。</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/DedicatedSupport.svg" width="40" height="40" alt="dedicated support" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>
                            專屬服務支援
                        </h3>
                        <p>專屬客戶經理將協助您的團隊充分發揮 Trinka 的效益，服務內容包括詳細的入門說明電話、協助文件以及操作影片導覽。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="border-top">
    <app-iplisting></app-iplisting>
</section>

<section class="list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-11 col-lg-10">
                            <div class="trinka-title mb-0 text-center">
                                <h2>全方位應用支援</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>透過針對各行業及職務量身打造的應用案例，深入了解 Trinka 的強大功能。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-none">
                                <h3>內容編輯強力助攻</h3>
                                <p>讓 Trinka 負責校正文法和進階的機械式錯誤，讓專業編輯能專注在語意和表達上，提升內容品質並優化工作流程。</p>
                                <ul>
                                    <li>縮短專案處理時間</li>
                                    <li>提升編輯品質</li>
                                    <li>加快出版速度</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>
                                    行銷團隊利器
                                </h3>
                                <p>幫助您的團隊輕鬆打造優質客戶郵件、行銷素材、溝通稿、報告與提案文件，提升專業度。</p>
                                <ul>
                                    <li>避免客戶溝通出錯尷尬</li>
                                    <li>輕鬆維持品牌調性與焦點

                                    </li>
                                    <li>縮短內容交付時間</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>編輯品質評估</h3>
                                <p>Trinka 的寫作評估 AI 提供有用的洞察，並可自訂評分與錯誤分類分析。</p>
                                <ul>
                                    <li>提供量化品質數據</li>
                                    <li>協助編輯人員招募</li>
                                    <li>帶來學習機會，附詳盡解說與建議</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>翻譯後自動文法檢查</h3>
                                <p>翻譯團隊可利用 Trinka 精準修正文法錯誤，並獲得品質報告。</p>
                                <ul>
                                    <li>上下文拼字檢查</li>
                                    <li>技術用語與句構優化</li>
                                    <li>支援高效率批次文件編輯</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-grammar-without-internet [windowsButton]="false"></app-grammar-without-internet>

<app-intergrade-software></app-intergrade-software>

<app-personal-pricing></app-personal-pricing>

<app-local-invoice></app-local-invoice>

<app-about-trinka></app-about-trinka>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">透過 Trinka 轉變您的企業溝通風格</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn nowrap" type="button">索取報價 </button>
                </div>
            </div>
        </div>
    </div>
</div>